'use client'

import { useEffect } from 'react'
import { landingpage_skills_exposure } from '@/constants/trace'
import { trackEvent, whenUmamiReady } from '@/lib/utils'

export function SkillPageExposure() {
  useEffect(() => {
    return whenUmamiReady(() => trackEvent(landingpage_skills_exposure))
  }, [])
  return null
}
